import AdvancedSearch from './advancedSearch';

// This component is used to render the Material Entity using AdvancedSearch based on the type of material
// It is used in MyMaterialHomePage.js
export default function MyMaterialComponent(props) {
  return (
    <div className="myHomePage-content">
      <div>
        <AdvancedSearch
          level="Material"
          key={props.matType}
          type={props.matType}
          myHomePage={true}
        />
      </div>
    </div>
  );
}
